import React from 'react';

export default function BuyerTargets() {
  const buyerCategories = [
    {
      title: "Combat Sports Promotions",
      description: "Perfect for major MMA and boxing organizations",
      examples: ["MMA Promotions", "Boxing Promotions", "Mixed Martial Arts", "Professional Boxing", "Combat Sports"],
      icon: "🥊",
      color: "from-champagne-gold to-yellow-600"
    },
    {
      title: "Media & Streaming Platforms",
      description: "Ideal for branding PPV packages and fight series",
      examples: ["Streaming Services", "Sports Networks", "PPV Platforms", "Fight Broadcasting", "Sports Media"],
      icon: "📺",
      color: "from-gray-600 to-gray-800"
    },
    {
      title: "Event Organizers",
      description: "Brand recurring title fight events and tournaments",
      examples: ["Independent Promoters", "Regional Leagues", "Tournament Organizers", "Fight Events", "Sports Events"],
      icon: "🏆",
      color: "from-champagne-gold to-yellow-700"
    },
    {
      title: "Sports Betting Platforms",
      description: "Create a combat sports focused sub-brand",
      examples: ["Betting Platforms", "Sports Books", "Gaming Companies", "Odds Providers", "Fantasy Sports"],
      icon: "🎯",
      color: "from-gray-700 to-gray-900"
    },
    {
      title: "Content Creators & Influencers",
      description: "Perfect for influencer boxing and MMA events",
      examples: ["Content Creators", "Social Media Influencers", "Podcast Networks", "YouTube Channels", "Digital Creators"],
      icon: "🎬",
      color: "from-champagne-gold to-yellow-800"
    },
    {
      title: "Digital & Fantasy Sports",
      description: "Virtual combat sports and NFT marketplaces",
      examples: ["Fantasy Sports", "NFT Platforms", "Gaming Companies", "Digital Sports", "Virtual Competitions"],
      icon: "🎮",
      color: "from-gray-600 to-gray-800"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 md:mb-6 leading-tight tracking-tight">
            PERFECT FOR INDUSTRY LEADERS
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-light">
            WorldTitleFight.com is the ideal domain for organizations seeking to establish 
            dominance in the combat sports industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {buyerCategories.map((category, index) => (
            <div
              key={index}
              className="bg-deep-charcoal/90 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-gray-700 hover:border-champagne-gold/50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br ${category.color} rounded-lg flex items-center justify-center text-xl md:text-2xl mb-3 md:mb-4 shadow-lg`}>
                {category.icon}
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3 leading-tight">
                {category.title}
              </h3>
              
              <p className="text-gray-300 mb-3 md:mb-4 text-sm md:text-base leading-relaxed font-light">
                {category.description}
              </p>
              
              <div className="space-y-2">
                <h4 className="text-xs md:text-sm font-semibold text-champagne-gold uppercase tracking-wider">
                  Industry Categories:
                </h4>
                <div className="flex flex-wrap gap-1.5 md:gap-2">
                  {category.examples.map((example, exampleIndex) => (
                    <span
                      key={exampleIndex}
                      className="px-2 py-1 md:px-3 md:py-1 bg-gray-800/80 text-gray-300 rounded-full text-xs md:text-sm font-medium border border-gray-700"
                    >
                      {example}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}